<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <h5>
          {{ getDeviceName(device.name) }} -
          <span :class="getDeviceClass(device.status)">{{
            getDeviceStatus(device.status)
          }}</span>
        </h5>
        <hr />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <canvas id="canvas" style="width: 100%; height: auto"></canvas>
      </div>
      <div class="col-12">
        <button @click="captureImage" class="btn btn-primary w-100 mt-2">
          Capture Image
        </button>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "@/layouts/main";
import UtilsMixin from "@/mixins/utils";
import Swal from "sweetalert2";

export default {
  props: {
    device: Object,
  },
  data() {
    return {
      activeCams: [],
    };
  },
  mixins: [UtilsMixin],
  components: {
    Layout,
  },
  beforeDestroy() {
    for (let cam of this.activeCams) {
      this.$socket.emit(
        "REQUEST:CAMERA_DEVICE",
        JSON.stringify({ command: "stop", id: cam })
      );
    }
  },
  mounted() {
    this.sockets.subscribe("CAMERA_DEVICE", (data) => {
      this.activeCams.push(data.port);
      setTimeout(() => {
        new JSMpeg.Player(`wss://adastest.transharyana.in:${data.port}`, {
          canvas: document.getElementById("canvas"),
        });
      }, 2000);
    });

    this.$socket.emit(
      "REQUEST:CAMERA_DEVICE",
      JSON.stringify({ url: this.device.url, command: "start" })
    );
  },
  methods: {
    captureImage() {
      Swal.fire("Captured", "Image has been saved to storage", "success");
    },
    getDeviceName(deviceCodeName) {
      switch (deviceCodeName) {
        case "front_camera_url":
          return "Front Camera";

        case "rear_camera_url":
          return "Rear Camera";

        case "body_camera_url":
          return "Body Camera";

        case "GPS":
          return "Location";

        default:
          return deviceCodeName;
      }
    },

    getDeviceStatus(status) {
      switch (status) {
        case true:
          return "ONLINE";

        case false:
          return "OFFLINE";

        case "LOADING":
          return "LOADING";

        default:
          return "UNKNOWN";
      }
    },

    getDeviceClass(status) {
      switch (status) {
        case true:
          return "text-success";

        case false:
          return "text-danger";

        default:
          return "text-warning";
      }
    },
  },
};
</script>